const initialState = {
    courierToken: !!localStorage.getItem('courierToken') ? localStorage.getItem('courierToken') : false,
    courierProfile: JSON.parse(localStorage.getItem('courierProfile')) ? JSON.parse(localStorage.getItem('courierProfile')) : {},
    courierPhoneNumber: '',
    password: '',
    inputClass: 'Input-InputWrapper-d',
    errorTxt: '',
};

const courierLogin = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUT_COURIER_LOGIN_PAGE':
            return {...state, [action.name]: action.value};
       	case 'CHANGE_COURIER_TOKEN':
            localStorage.setItem('courierToken', action.token);
            return {...state, courierToken: action.token};
        case 'CHANGE_COURIER_PROFILE_DATA':
            localStorage.setItem('courierProfile', JSON.stringify(action.info));
            return {...state, courierProfile: action.info};
        case 'LOG_OUT_COURIER':
            localStorage.removeItem('courierToken');
            localStorage.removeItem('courierProfile');
            return {...initialState, courierToken: false, courierProfile: {}};
        default:
            return state;
    }
};

export default courierLogin;
